export const MAP_SPEED_OVERRIDE_SEARCH_SPEED_OVERRIDE = "MAP_SPEED_OVERRIDE_SEARCH_SPEED_OVERRIDE";
export const MAP_SPEED_OVERRIDE_SEARCH_SPEED_OVERRIDE_CLEAR = "MAP_SPEED_OVERRIDE_SEARCH_SPEED_OVERRIDE_CLEAR";
export const MAP_SPEED_OVERRIDE_SEARCH_SPEED_OVERRIDE_RESPONSE = "MAP_SPEED_OVERRIDE_SEARCH_SPEED_OVERRIDE_RESPONSE";
